import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

const LOGO_URL =
  "/assets/logo.png";

const PaymentCancel = () => {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-white flex flex-col px-5 marketing-mobile-shrink">
      <header className="pt-6 pb-2">
        <Link to="/" className="inline-flex items-center" data-testid="logo-link">
          <img src={LOGO_URL} alt="Le Guide des Entrepreneurs" className="h-9 sm:h-10 w-auto" />
        </Link>
      </header>
      <div className="flex-1 flex items-center justify-center">
        <div className="max-w-md text-center" data-testid="payment-cancel-page">
          <XCircle className="w-14 h-14 mx-auto text-gray-500" />
          <h1 className="font-heading font-black text-3xl tracking-tighter mt-6">Paiement annulé</h1>
          <p className="text-gray-600 mt-3">Aucun montant n'a été prélevé. Vous pouvez reprendre votre commande quand vous le souhaitez.</p>
          <Button onClick={() => nav("/")} className="mt-6 rounded-none bg-[#1E2A5E] hover:bg-[#2FA398]" data-testid="cancel-back-btn">
            Retour aux modèles
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
